import React from 'react';
import './loader.scss';
export function Loader({ className = "" }) {
  return <div className={"fullscreen-loader " + className}><div className="lds-roller"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div></div>
}